import React, { useEffect, useState, useCallback } from 'react';
import { fetchUtils, usePermissions, useRedirect } from 'react-admin';
import { IconButton, Popover, Tooltip, Badge } from '@material-ui/core';
import { Notifications, NotificationsActive } from '@material-ui/icons';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const fetch = fetchUtils.fetchJson;
const requestOptions = {headers: new Headers()};

const StyledBadge = withStyles((theme) => ({
  badge: {color: '#f44336', backgroundColor: '#fff', right: '8px', top: '29px', height: '13px', minWidth: '10px', padding: '0 4px'}
}))(Badge);

const useStyles = makeStyles({
  paper: {
    overflowX: "unset",
    overflowY: "unset",
    "&::before": {
        content: '""',
        position: "absolute",
        marginRight: "-0.71em",
        bottom: 0,
        right: 0,
        width: 10,
        height: 10,
        // backgroundColor: theme.palette.background.paper,
        // boxShadow: theme.shadows[1],
        transform: "translate(-50%, 50%) rotate(135deg)",
        clipPath: "polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))",
    },
  }
});

export const NotificationsComponent = ({loading, ...props}) => {
  const classes = useStyles(props);
  

  const { className, ...rest } = props;
  const { permissions } = usePermissions();
  let [results, setResults] = useState();
  let [anchorEl, setAnchorEl] = useState();
  let [data, setData] = useState([]);
  let [clicked, setClicked] = useState(false);
  let [hasNotifications, setHasNotifications] = useState(0);

  const handleClose = (x) => {
    setAnchorEl(null)
  };

  const queryNotifications = useCallback( async () => {
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    const url = window.nobid_endpoint + `/alarms?opened_at=false`;
    const response = await fetch(url, requestOptions);
    const responseData = response.json;
    setData(responseData);
    setHasNotifications(responseData.length);
  }, []);

  const getNotifications = async (input) => {
    setClicked(true);
    queryNotifications();
    const currentTarget = input.currentTarget.parentNode;
    setAnchorEl(currentTarget);
    setResults(data);
    setClicked(false);
  }

  useEffect(() => {
    queryNotifications();
  }, [loading]);

  const open = Boolean(anchorEl);
  const redirect = useRedirect();

  return (
    <div style={{ position: 'relative' }} >
      { hasNotifications ?
        <Tooltip title='Alarms'>
          <StyledBadge badgeContent={hasNotifications} >
            <IconButton onClick={ () => { redirect('/alarms') } }>
              <NotificationsActive/>
            </IconButton>
          </StyledBadge>
        </Tooltip> :
          <IconButton onClick={ () => { redirect('/alarms') } }>
            <Notifications />
          </IconButton>
        }
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: -5
        }}
        classes={{ paper: classes.paper }}
        onClose={handleClose}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        InputLabelProps={{shrink: false}}
      >
        <div style={{borderBottom: '1px solid white'}}>
          <h3 style={{margin: '10px 20px'}}>Alerts</h3>
        </div>
        <ul style={{minWidth: 500, maxWidth: 600, paddingLeft: '0px', overflowY: 'scroll', maxHeight: window.innerHeight - 300, fontSize: '12px'}}>
          { results && results.length > 0 ?
            results.map(x =>
              <div style={{borderBottom: '1px solid grey'}}>
                <li style={{listStyle: 'none', margin: '10px 20px'}}>
                  <b>{x.type}</b>
                  <p>{x.message}</p>
                </li>
              </div>
            ) : 'No new alarms'
          }
        </ul>
      </Popover>
    </div>
  );
};
